module.exports = __webpack_public_path__ + "static/media/head.ff9f9a01.jpg";